import { render } from "./ChatMemberBadge.vue?vue&type=template&id=75b8e68d"
import script from "./ChatMemberBadge.vue?vue&type=script&lang=js"
export * from "./ChatMemberBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__